<template>
  <div class=" bg-white">
    <div class="p-6 shadow-border-b">
      <p class="font-bold text-lg mb-6">Info Role</p>
      <div class="flex justify-between items-start gap-6">
        <div class="flex-1">
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
            <p class="text-neutral-500">{{ roleDetail.id }}</p>
          </div>
          <div class="">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Role</label>
            <p class="text-neutral-500">{{ roleDetail.name }}</p>
          </div>
        </div>
        <div class="flex-1">
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Deskripsi</label>
            <p class="text-neutral-500">{{ roleDetail.description || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="p-6">
      <p class="font-bold text-lg mb-6">Capability</p>
      <masonry :cols="3" :gutter="30">
        <div v-for="(item, index) in roleDetail.permissions" :key="index">{{ item.id }}</div>
      </masonry>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('role', ['roleDetail']),
    roleId() {
      return this.$route.params.id
    }
  },
  created() {
    this.getRoleInfo()
  },
  methods: {
    ...mapActions('role', ['getRoleDetail']),
    getRoleInfo() {
      this.getRoleDetail({
        id: this.roleId
      })
    }
  }
}
</script>
